import { z } from 'zod';
import { httpApi } from './basicHttpApi';
import { ProxyPoolRotationSchema } from '../biz/proxyPoolRotationOptions';
import { ProxyPoolProtocolSchema } from '../biz/proxyPoolProtocolOptions';

const PoolSchema = z.object({
  id: z.number(),
  cities: z.array(z.string()),
  countries: z.array(z.string()),
  rotation: ProxyPoolRotationSchema,
  protocol: ProxyPoolProtocolSchema,
  pool_name: z.string(),
  proxy_type: z.union([
    z.literal('residential'),
    z.literal('mobile'),
    z.literal('datacenter'),
  ]),
  subscription_id: z.number(),
});

export type PoolType = z.infer<typeof PoolSchema>;

export const fetchProxyPool = async (poolId: number) => {
  const result = await httpApi(`pools/pool/${poolId}`, undefined, 'GET');
  return PoolSchema.parse(result);
};
